import React from 'react';


export const ECS = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/ecs.png')} />
    )
};
